define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def/ViewRef",
	"csi/heading/AggregateController",
	"csi/widget/MessageDialog",
	"csi/xml",
	"Specification",
	"./AggregateIncrementSizesMixin"
], function(declare, lang, csi, ViewRef, AggregateController, MessageDialog, xml, Specification, AggregateIncrementSizesMixin) {

	return declare(AggregateIncrementSizesMixin, {

		getAggregateSizesViewRef: function() {
			return lang.mixin(new ViewRef(), {
				m_url: Specification.URL_ADMIN,
				m_id: "AggregateSizeChartSizeRange"
			});
		},

		toWriter: function() {
			// summary: write request to server
			var formData = this.getFormData();
			var urlOldSizeRange = this.getCurrentSizeRangeUrl(this.getNode());

			var urlSizeRange = this.newValue;
			if (!urlSizeRange) {
				// User changes SizeRange on the dialog
				var selectedNode = formData.getSelectedNode(true);
				urlSizeRange = selectedNode ? selectedNode.$URL : csi.EMPTY_URL;
			}

			// write request if change was made
			if (urlSizeRange != urlOldSizeRange) {
				this._writeRequest()
					.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.m_urlNode)
					.addParameter("SizeRangeURL", xml.ATTR_REF, urlSizeRange);

				this.setProgress();
			}
		},

		getConfirmButton: function() {
			return MessageDialog.BUTTON_CHANGE;
		},

		/**
		 * @override
		 * Selecting a new size range is required if there is already an existing 2d size range
		 */
		isValueRequired() {
			return this.inherited(arguments) || this._hasTwoDimSizeRange(this.getContext());
		},

		onConfirm: function(/*String*/key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == MessageDialog.BUTTON_CHANGE) {
				AggregateController.prototype.publish.call(this);
			} else {
				this.postProcess();
			}
		},

		publish: function() {
			// summary: if Increment has SizeRange confirm action before changing/deselect SizeRange
			if (xml.isValidURL(this._getIncrement().IncrementSizeRange)) {
				this.confirmAction({});
			} else {
				this.inherited(arguments);
			}
		},

		postProcessSuccess: function() {
			// refresh store for base size selection if wizard shown or sizes were changed
			var view = this.widget;
			view.refreshHeadingStore(view.defView.findHeading(this.idBaseSize));

			this.inherited(arguments);
		}
	});
});